<template>
  <el-row type="flex" justify="center">
    <el-col :xs="{ span: 20 }" :sm="{ span: 20 }" :md="{ span: 16 }">
      <el-container class="card auto-width">
        <el-row>
          <el-col>
            <span class="title">{{ strings.title }}</span>
          </el-col>
          <el-col class="py-2">
            <el-steps :active="3" finish-status="success" align-center>
              <el-step />
              <el-step />
              <el-step />
              <el-step />
              <el-step />
            </el-steps>
          </el-col>
        </el-row>
        <el-row>
          <el-col
            class="scrollable black-border text-block"
            style="scroll-behavior: smooth;"
            @scroll.native="detectScroll"
          >
            <!-- <h1>{{terms_heading}}</h1> -->
            <p>
              Thank you for bringing in your items to <b>labelswap™</b>. In our
              world you are now known as a SELLER. Once accepted by an
              associate, your items are in the system to be reviewed. Your items
              will be sorted and potentially selected for purchase based on
              condition, style, store need, and demand for resale. Items we
              select and approve for purchase will be logged into our system
              which will help us determine current inventory, demand, and a
              suggested resale price. You will be provided with an offer sheet
              which provides you options to accept cash or store credit for the
              items we accept. In most cases, the store credit option will
              result in a higher payout to SELLER. SELLERS who chose store
              credit can utilize the credit immediately or labelswap™ will hold
              the credit value for a maximum period of 12 months. The credit
              expires 12 months from the date the credit is given and will not
              be honored after that date. The credit has no separate cash value.
              Multiple credits can be stacked if you are banking for a larger
              purchase.
            </p>

            <p>
              SELLERS are required to accept our Terms of Service to initiate
              the process, produce a valid photo ID, and provide your contact
              information including a valid telephone and email address to be
              eligible for <b>labelswap™</b> service. Unselected items will be
              donated / disposed of according to the Terms of Service, which is
              subject to change.
            </p>

            <p>
              SELLERS can drop off items and a Labelswap associate will contact
              you via telephone, text, or email to let you know your items have
              been processed, usually within 24 hours. If you choose to drop off
              items you agree to the same terms of services outlined below.
            </p>

            <p>
              For fastest service, please do not bring your items in on hangers
              or in storage containers. We cannot be responsible for items being
              misplaced, returning hangers, or returning containers so please
              consider this when preparing for a visit to <b>labelswap™</b>.
            </p>

            <p>
              Items that are not selected by <b>labelswap™</b> must be picked up
              within 24 hours of the notice time or they will be donated. If you
              are unable to pick up your items and contact the store within the
              24-hour period, your items will be held for one additional 24-hour
              period only.
            </p>

            <h1>labelswap™ TERMS OF SERVICE</h1>

            <p>
              SELLERS AGREE TO SELL THEIR ITEMS FOR THE PRICE SET BY
              <b>labelswap™</b> OR ACCEPT THE CREDIT VALUE PROVIDED BY
              <b>labelswap™</b> AT THE TIME OF THE TRANSACTION. CREDIT VALUE CAN
              BE USED IMMEDIATELY OR HELD AT THE STORE FOR A MAXIMUM OF 12
              MONTHS.
            </p>

            <p>
              SELLERS AUTHORIZE <b>labelswap™</b> TO CHOOSE, TAG, AND SELL THE
              ITEMS THEY SELECT IN EXCHANGE FOR THE VALUE OFFERED.
            </p>
            <p>
              <b>labelswap™</b> WILL HAVE CUSTOMER PAYMENT AVAILABLE AT THE
              CONCLUSION OF THE PROCESS ONLY. CUSTOMER WILL RECEIVE A PHONE
              CALL, EMAIL, OR TEXT MESSAGE (ONE ONLY) INDICATING THE PROCESS HAS
              BEEN COMPLETED.
            </p>
            <p>
              ITEMS NOT SELECTED BY <b>labelswap™</b> WILL BE RETURNED TO
              CUSTOMER IN A TIMELY MANNER OR DONATED OR DISPOSED OF 24 HOURS
              AFTER NOTICE IS SENT TO YOU OF COMPLETION OF THE PROCESS. IF
              CUSTOMER CANNOT RETRIEVE ITEMS IN THIS PERIOD CUSTOMER MUST
              CONTACT THE STORE IMMEDIATELY. IF CUSTOMER CONTACTS THE STORE
              WITHIN 24 HOURS, THE ITEMS WILL BE HELD FOR AN ADDITIONAL 24 HOURS
              ONLY AND WILL THEN BE DONATED OR DISPOSED OF. NO REQUESTS FOR
              ADDITIONAL EXTENSIONS OF TIME WILL BE HONORED.
            </p>
            <p>
              ONCE THE PROCESS HAS BEEN COMPLETED, CUSTOMER WILL NOT BE ABLE TO
              RECLAIM ITEMS FROM THE RACK, SHELVES OR DISPOSAL / DONATION BIN.
            </p>
            <p>
              CUSTOMER MUST PROVIDE VALID PHOTO IDENTIFICATION PAYMENT AND AS
              REQUIRED BY LAW.
            </p>
            <p>
              BY SIGNING BELOW, CUSTOMER REPRESENTS, WARRANTS AND AGREES THAT:
              (1) HE OR SHE HAS CLEAR, UNENCUMBERED TITLE TO ALL PROPERTY BEING
              SOLD, TRADED, OR CREDITED; (2)HAS THE RIGHT TO SELL OR EXCHANGE
              THE PROPERTY TO <b>LABELSWAP™</b>; THAT ALL PROPERTY HAS BEEN
              LEGALLY OBTAINED; (3) THAT ALL BRANDED GOODS ARE GENUINE AND DO
              NOT INFRINGE ANY PATENT, TRADEMARK, COPYRIGHT OR OTHER
              INTELLECTUAL PROPERTY RIGHTS; AND, (4) ALL KNOWN MATERIAL DEFECTS
              HAVE BEEN DESCRIBED OR MADE KNOWN AND NOT CONCEALED. IF AN ITEM IS
              DETERMINED TO BE COUNTERFEIT, THE STORE CREDIT WILL BE REMOVED
              FROM THE SELLERS ACCOUNT.
            </p>
            <p>
              CUSTOMER AGREES TO INDEMNIFY AND HOLD (<b>LABELSWAP™</b>), ITS
              EMPLOYEES, OFFICERS, AND THE BUYER OF THE GOODS (THE “INDEMNIFIED
              PARTIES”) HARMLESS FROM ANY CLAIM TO OWNERSHIP OF THE GOODS SOLD
              BY CUSTOMER OR ANY CLAIM THAT THE GOODS VIOLATE THE INTELLECTUAL
              PROPERTY OF ANY PERSON OR ENTITY AND SHALL DEFEND AND INDEMNIFY
              EACH INDEMNIFIED PARTY INCLUDING PAYMENT OF DEFENSE COSTS AS
              INCURRED.
            </p>
            <p>
              CUSTOMER WAIVES ANY CLAIM AGAINST THE INDEMNIFIED PARTIES FOR ANY
              AND ALL LOSS OR DAMAGE TO CUSTOMER PROPERTY DURING THE DROP OFF
              PERIOD OR SALE PROCESS. CUSTOMER AUTHORIZES <b>LABELSWAP™</b>, ITS
              ASSIGNS, SUCCESSORS, OR SERVICING AGENTS TO COMMUNICATE VIA SMS
              TEXT NOTIFICATION TO ANY NUMBER PROVIDED TO LABELSWAP. CUSTOMER
              AGREES TO ACCEPT ANY AND ALL CHARGES OR FEES ASSOCIATED WITH
              MOBILE COMMUNICATION FROM <b>LABELSWAP™</b> INCLUDING FEES FROM
              MOBILE SERVICE PROVIDERS.
            </p>
          </el-col>
        </el-row>
        <el-row class="mt-1" type="flex">
          <el-col :span="6" class="text-left">
            <el-button type="default" @click="back">
              {{ strings.backBtn }}
            </el-button>
          </el-col>
          <el-col :span="12" class="text-right" v-show="isActionDropoff">
            <el-button type="info" class="form-button sm" @click="handleDropoffDonateToggle">
              {{toggleButtonText}}
            </el-button>
          </el-col>
          <el-col :span="6" class="text-right">
          </el-col>
          <el-col :span="12" class="text-right">
            <el-button type="info" class="form-button sm" @click="agree">
              {{agreeButtonText}}
            </el-button>
          </el-col>
        </el-row>
      </el-container>
    </el-col>
  </el-row>
</template>

<script>
import idleTimeout from "idle-timeout";

/*
  This constant defines on what scroll % the Agree button is unlocked
  (0: no scroll, 1: all possible scroll)
*/
const SCROLL_BTN_UNLOCK = 0.75;

// Component scope timeout variable
let scrollTimeout;

export default {
  name: "AgreementPage",
  data() {
    return {
      loading: false,
      lockAgreeBtn: true,
      strings: {
        title: "Terms of Agreement",
        backBtn: "Back",
        agreeBtn: {
          label: "Agree",
          loading: "Please wait...",
        },
      },
    };
  },
  computed: {
    agreeButtonText: function () {
      const selectedAction = this.$store.getters["shopper/selectedAction"];
      const dropoffDonateRemaining = this.$store.getters[
        "shopper/dropoffDonateRemaining"
      ];

      if (selectedAction === "instorewaitlist"){
        return "I agree to wait in the store during the process";
      } else {
        return dropoffDonateRemaining
          ? "I agree to sign off my items with no review"
          : "I agree to drop off my items";
      }
    },
    isActionDropoff: function () {
      return this.$store.getters["shopper/selectedAction"] === "dropoff";
    },
    toggleButtonText: function () {
      return this.$store.getters["shopper/dropoffDonateRemaining"]
        ? "I changed my mind, I want to review my items"
        : "I changed my mind, I want to donate what doesn’t fit the offer";
    },
    terms_heading: function () {
      if (this.$store.getters["shopper/selectedAction"] === "instorewaitlist") {
        return "testing: meant for in-store waitlist";
      } else {
        if (this.$store.getters["shopper/dropoffDonateRemaining"]) {
          return "testing: meant for drop-off e-signature";
        } else {
          return "testing: meant for drop-off review items";
        }
      }
    }
  },
  mounted() {
    scrollTimeout = idleTimeout(
      () => {
        /*
         * This callback executes when on timeout
         * It scrolls the terms all the way to the last title in the bottom
         */
        const scrollContainer = document.querySelector(".scrollable");
        const lastTitle = document.querySelector(".scrollable h5:last-child");
        scrollContainer.scrollTop = lastTitle.offsetTop;
      },
      {
        element: document,
        timeout: 1000 * 4,
        loop: false,
      }
    );
  },
  beforeDestroy() {
    // Prevent memory leaks (we all know Google's V8 engine...)
    scrollTimeout.destroy();
  },
  methods: {
    agree() {
      this.$router.push("/transaction");
    },
    back() {
      this.$router.push("/edit-customer");
    },
    detectScroll(e) {
      // Calculate the scroll
      const perc = e.target.scrollTop / e.target.scrollHeight;
      // Unlock agree button if threshold is reached
      if (perc >= SCROLL_BTN_UNLOCK) {
        this.lockAgreeBtn = false;
      }
    },
    handleDropoffDonateToggle() {
      this.$store.getters["shopper/dropoffDonateRemaining"]
        ? this.$store.commit("shopper/setDonateRemaining", false)
        : this.$store.commit("shopper/setDonateRemaining", true);
    },
  },
};
</script>
